import { render, staticRenderFns } from "./StakeMain.vue?vue&type=template&id=6719a4ec"
import script from "./StakeMain.vue?vue&type=script&lang=js"
export * from "./StakeMain.vue?vue&type=script&lang=js"
import style0 from "./StakeMain.vue?vue&type=style&index=0&id=6719a4ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports